import api from './api';

// Tamanho de página do autocomplete dos selects (#329): poucas opções bastam,
// quem não achou refina o termo.
const TAMANHO_BUSCA_SELECT = 20;

// CRUDs simples de apoio (motoristas, variedades, transportadoras) — listagem paginada.
const crud = (recurso, sort) => ({
    listar: (busca = '', page = 0, size = 20) => {
        const params = { page, size, sort };
        if (busca) params.busca = busca;
        return api.get(`/${recurso}`, { params }).then((r) => r.data);
    },
    // Para os selects: autocomplete server-side, já filtrado e ordenado por nome.
    buscar: (termo = '') =>
        api.get(`/${recurso}`, { params: { page: 0, size: TAMANHO_BUSCA_SELECT, sort, busca: termo } })
            .then((r) => r.data.content),
    criar: (dados) => api.post(`/${recurso}`, dados).then((r) => r.data),
    atualizar: (id, dados) => api.put(`/${recurso}/${id}`, dados).then((r) => r.data),
    remover: (id) => api.delete(`/${recurso}/${id}`),
});

export const motoristas = {
    ...crud('motoristas', 'nome'),
    // A listagem completa traz CPF e RG e exige CADASTROS_GERENCIAR. Para os
    // selects das telas de fila basta id + nome, que qualquer usuário autenticado
    // pode ler — quem registra entrada não precisa de permissão de cadastro.
    buscar: (termo = '') => api.get('/motoristas/selecao', { params: { busca: termo } }).then((r) => r.data.itens),
};
// `listar` (grade de cadastro) traz ativo e inativo, para poder reativar. Nos
// selects de fila só o ativo faz sentido — filtra depois de buscar no servidor.
const buscarSoAtivos = (recurso, sort) => (termo = '') =>
    crud(recurso, sort).buscar(termo).then((itens) => itens.filter((i) => i.ativo));

export const variedades = {
    ...crud('variedades', 'nome'),
    buscar: buscarSoAtivos('variedades', 'nome'),
};
export const transportadoras = {
    ...crud('transportadoras', 'nome'),
    buscar: buscarSoAtivos('transportadoras', 'nome'),
};
export const impressoras = crud('impressoras', 'nome');

// Produtos de expedição (o que sai no romaneio). `ativos` alimenta a escolha no
// "Digitar romaneio": a lista de uma fecularia é curta, então vem inteira e o
// filtro por código ou descrição roda na tela, sem ida ao servidor por tecla.
export const produtos = {
    ...crud('produtos', 'descricao'),
    ativos: () => api.get('/produtos', { params: { page: 0, size: 1000, sort: 'descricao' } })
        .then((r) => r.data.content.filter((p) => p.ativo)),
    importarCsv: (arquivo) => {
        const form = new FormData();
        form.append('arquivo', arquivo);
        return api.post('/produtos/importacao', form).then((r) => r.data);
    },
};

// Sugestões de vínculo placa-motorista por recorrência (issue #526). Não é
// CRUD: nasce sozinha na entrada da fila, só resta listar por situação e decidir.
export const vinculosPlaca = {
    listar: (status) => api.get('/vinculos-placa', { params: { status } }).then((r) => r.data),
    confirmar: (id) => api.put(`/vinculos-placa/${id}/confirmacao`).then((r) => r.data),
    recusar: (id) => api.put(`/vinculos-placa/${id}/recusa`).then((r) => r.data),
    // Aviso nas telas de fila. Sem permissão de gerenciar vínculo, nem chama —
    // 403 silencioso não é aviso, é ruído no console de quem não decide isso.
    contarPendentes: () => api.get('/vinculos-placa/pendentes/contagem').then((r) => r.data),
    // Pré-preenchimento na tela de entrada: placa digitada já tem motorista
    // vinculado? 204 (sem vínculo) vira null, não erro.
    buscarMotoristaPorPlaca: (placa) => api.get('/vinculos-placa/motorista', { params: { placa } })
        .then((r) => (r.data ? { id: r.data.motoristaId, nome: r.data.motoristaNome } : null))
        .catch(() => null),
};
